import { ResourceProps } from "react-admin";
import Icon from "@mui/icons-material/NightShelter";
import { Resource } from "../../enums";
import ListScreen from "./list";
import { EditScreen } from "./edit";

const accessibilityPage: ResourceProps = {
  name: Resource.ACCESSIBILITY,
  icon: Icon,
  list: ListScreen,
  edit: EditScreen,
  options: {
    label: "Accessibility",
  },
};

export default accessibilityPage;
